import Api from "@src/api";
export const ApiDisaster = {
  // category distaster

  addCategory(data) {
    return Api().post(`Disaster/Categories`, data);
  },
  updateCategory(data, id) {
    return Api().put(`Disaster/Categories/${id}`, data);
  },
  deleteCategory(id) {
    return Api().delete(`Disaster/Categories/${id}`);
  },
  searchCategory(params) {
    return Api().get(`Disaster/Categories`, {
      params,
    });
  },
  getDetailCategory(id) {
    return Api().get(`Disaster/Categories/${id}`);
  },

  uploadFile(formData) {
    return Api().post(`FileUpload/DisasterAttachment`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  // Disaster
  addDisaster(data) {
    return Api().post(`Disaster`, data);
  },
  updateDisaster(data, id) {
    return Api().put(`Disaster/${id}`, data);
  },
  deleteDisaster(id) {
    return Api().delete(`Disaster/${id}`);
  },

  searchDisaster(params) {
    return Api().get(`Disaster`, {
      params,
    });
  },
  getDetailDisaster(id) {
    return Api().get(`Disaster/${id}`);
  },
  addFeedBack(data, id) {
    return Api().post(`Disaster/${id}`, data);
  },
  deleteFeedBack(id, indconv) {
    return Api().delete(`Disaster/${id}/${indconv}`);
  },
  updateFeedback(data, id, indconv) {
    return Api().put(`Disaster/${id}/${indconv}`, data);
  },

  changeStatus(id, status) {
    return Api().put(`Disaster/${id}/ChangeStatus/${status}`);
  },
  remind(id) {
    return Api().post(`Disaster/${id}/Remind`);
  },
};
